// 2_components/header_left_to_free_shipping.js
// Builds the "X left for free shipping" / "free shipping reached" banner in the
// header from Shoptet's cartInfo, updates a progress CSS variable, and mirrors the
// banner into the cart widget.

let freeShippingElementCopy;

export function init() {
	createFreeShippingInfo();
	document.addEventListener("ShoptetCartUpdated", function () {
		createFreeShippingInfo();
	});

	document.addEventListener("ShoptetDOMCartContentLoaded", function () {
		freeShippingInfoInCartWidget();
	});
}

function createFreeShippingInfo() {
	if (!dataLayer[0].shoptet?.cartInfo) return;

	const { freeShipping, leftToFreeShipping } = dataLayer[0].shoptet.cartInfo;
	if (freeShipping == null) return;

	const navigationButtons = document.querySelector("#header .navigation-buttons");
	if (!navigationButtons) return;

	const freeShippingElementPrevious = document.querySelectorAll(".header-free-shipping-info");
	if (freeShippingElementPrevious && freeShippingElementPrevious.length > 0) {
		freeShippingElementPrevious.forEach((element) => {
			element.remove();
		});
	}

	const freeShippingElement = document.createElement("div");
	freeShippingElement.classList.add("header-free-shipping-info");

	const leftToFreeShippingPrice = leftToFreeShipping?.priceLeft;
	if (!leftToFreeShippingPrice) return;

	const leftToFreeShippingPriceFormatted = leftToFreeShipping?.formattedPrice;
	if (!leftToFreeShippingPriceFormatted) return;

	if (freeShipping || leftToFreeShippingPrice <= 0) {
		// Free shipping reached
		const textOne = document.createElement("span");
		textOne.classList.add("free-shipping-text-one");
		textOne.innerText = window.NAT.translations("reachedFreeDelivery_1") + " ";

		const textTwo = document.createElement("span");
		textTwo.classList.add("free-shipping-text-two");
		textTwo.innerText = window.NAT.translations("reachedFreeDelivery_2");

		freeShippingElement.appendChild(textOne);
		freeShippingElement.appendChild(textTwo);

		document.body.classList.add("has-free-shipping");
	} else {
		// Show amount left for free shipping
		document.body.classList.remove("has-free-shipping");

		const textOne = document.createElement("span");
		textOne.classList.add("free-shipping-text-one");
		textOne.innerText = window.NAT.translations("buyMoreForFreeDelivery_1") + " ";

		const amount = document.createElement("b");
		amount.classList.add("free-shipping-amount");
		amount.innerText = leftToFreeShippingPriceFormatted;

		const textTwo = document.createElement("span");
		textTwo.classList.add("free-shipping-text-two");
		textTwo.innerText = window.NAT.translations("buyMoreForFreeDelivery_2");

		textOne.appendChild(amount);
		freeShippingElement.appendChild(textOne);
		freeShippingElement.appendChild(textTwo);

		let percentageProgressToFreeShipping = 0;

		let cartTotal = dataLayer[0].shoptet.cartInfo.getNoBillingShippingPrice.withVat || 0;

		const leftToFreeShippingRounded = Math.round(leftToFreeShippingPrice);
		cartTotal = Math.round(cartTotal);

		percentageProgressToFreeShipping =
			100 - Math.round((leftToFreeShippingRounded / (cartTotal + leftToFreeShippingRounded)) * 100);
		const cartWidget = document.querySelector("#cart-widget");
		if (cartWidget) {
			cartWidget.style.setProperty("--free-shipping-progress", percentageProgressToFreeShipping + "%");
		}

		const cartWrapperInOrder = document.querySelector("#cart-wrapper");
		if (cartWrapperInOrder) {
			cartWrapperInOrder.style.setProperty("--free-shipping-progress", percentageProgressToFreeShipping + "%");
		}
	}

	freeShippingElementCopy = freeShippingElement;

	navigationButtons.prepend(freeShippingElement);
}

function freeShippingInfoInCartWidget() {
	if (!freeShippingElementCopy) return;

	const cartWidgetFreeShipping = document.querySelector("#cart-widget .cart-free-shipping");
	if (!cartWidgetFreeShipping) {
		return;
	}

	cartWidgetFreeShipping.innerHTML = freeShippingElementCopy.outerHTML;
}
